module.exports = __webpack_public_path__ + "img/logo-login.e6e12b7b.png";